<template>
  <div :class="ui.bkgdColor">
    <v-layout row class="ml-2" v-if="this.data.tag === 'D1'">
      <v-flex xs12>
        <v-icon :color="ui.btnColor"> schedule </v-icon>
        <a :class="ui.textDescription">  {{ dateTypeB(data.item.dcrt) }} - </a>
        <a :class="ui.textDescription"> {{ dateTimeAgo(data.item.dcrt) }} ago </a>
      </v-flex>
    </v-layout>
    <v-layout wrap row class="ml-0 mt-2" v-if="this.data.tag === 'D3'">
        <v-icon left :color="ui.btnColor"> schedule </v-icon>
        <a :class="ui.textDescription">  {{ dateTypeB(data.item.stats.dcrt) }} </a>
        <a :class="ui.textDescriptionBkgd"> x </a>
        <a :class="ui.textDescription"> - </a>
        <a :class="ui.textDescriptionBkgd"> x </a>
        <a :class="ui.textDescription"> {{ dateTimeAgo(data.item.stats.dcrt) }} </a>
    </v-layout>
    <v-layout row class="ml-0" v-if="this.data.tag === 'D1'">
      <v-flex xs12>
        <v-icon :color="ui.btnColor"> person </v-icon>
        <a :class="ui.textDescription"> {{data.item.uname}} </a>
      </v-flex>
    </v-layout>
    <v-layout row class="ml-0" v-if="this.data.tag === 'D3'">
      <v-icon left :color="ui.btnColor"> person </v-icon>
      <a :class="ui.textDescription"> {{data.item.stats.uname}} </a>
    </v-layout>
    <v-layout row class="ml-2" v-if="this.data.tag === 'D1'">
      <v-flex xs12>
        <v-icon :color="ui.btnColor"> playlist_add </v-icon>
        <a :class="ui.textDescription"> {{data.item.modn}} data mods. </a>
      </v-flex>
    </v-layout>
    <v-layout row class="ml-2" v-if="this.data.tag === 'D1'">
      <v-flex xs12>
        <v-icon :color="ui.btnColor"> short_text </v-icon>
        <a :class="ui.textDescription"> {{data.item.modc}} </a>
      </v-flex>
    </v-layout>
    <!-- <v-layout wrap row class="ml-2" v-if="this.data.tag === 'D3'">
        <v-icon left :color="ui.btnColor"> short_text </v-icon>
        <a :class="ui.textDescription">
          {{data.item.char.tnoun}}
        </a>
        <a :class="ui.textDescriptionBkgd"> x </a>
        <a :class="ui.textDescriptionBold"
        v-if="this.data.item.char.tag !== 'U1'">
          {{data.item.char.title}}
        </a>
        <a :class="ui.textDescriptionBkgd"
        v-if="this.data.item.char.tag !== 'U1'"> x </a>
        <a :class="ui.textDescription">
          {{data.item.char.tverb}}
        </a>
    </v-layout> -->
    <v-layout row class="ml-2" v-if="this.data.tag === 'D2'">
      <v-flex xs12>
        <v-icon :color="ui.btnColor"> create </v-icon>
        <a :class="ui.textDescription"> Revision {{ docRevr1_r2_r3_r4(data.item.doc.rev) }} </a>
        <a class="ml-2"/>
        <v-icon :color="ui.btnColor"> playlist_add </v-icon>
        <a :class="ui.textDescription"> {{data.item.doc.rev.modn}} data mods. </a>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import revFunctions from "@/data/functions/mixins/revFunctions.js";

export default {
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      valid: true
    };
  },
  mixins: [apptheme, dateFunctions, apptheme, revFunctions],
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getUnsavedMaintStrategyIndication", "getCurrentPage"]),
    nameText() {
      let k = "body-1";
      let temp = this.ui.textColor + "--text ";
      k = temp + k;
      return k;
    },
    dateText() {
      let k = "body-1";
      let temp = this.ui.textColor + "--text ";
      k = temp + k;
      return k;
    },
    timeText() {
      let k = "body-1";
      let temp = this.ui.textColor + "--text ";
      k = temp + k;
      return k;
    },
    appSavedIconStatusColor() {
      // eslint-disable-next-line
      if (this.getUnsavedMaintStrategyIndication === true && this.getCurrentPage === "/maintstrategyedit") {
        return "wplorange0";
      } else {
        return this.ui.bkgdColor;
      }
    }
  }
};
</script>
